<template>
  <div class="timeline-item">
    <div class="timeline-badge">
      <div :style="markerStyle" :class="markerClasses"></div>
    </div>
    <div class="timeline-content">
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    markerColor: String,
    lineColor: String,
    isFilled: Boolean,
    isLast: Boolean,
    isVisible: Boolean
  },
  mounted() {
    this.updateLineHeight();
  },
  updated() {
    this.updateLineHeight();
  },
  data() {
    return {
      heightAfter: 24
    };
  },
  watch: {
    isVisible() {
      this.updateLineHeight();
    }
  },
  computed: {
    markerClasses() {
      return this.isFilled ? 'marker circle filled' : 'marker circle';
    },
    markerStyle() {
      const displayAfter = !this.isLast ? 'block' : 'none';

      return `
        --marker-margin-left: ${this.markerMarginLeft};
        --marker-height-after: ${this.markerHeightAfter};
        --display-after: ${displayAfter};
        --margin-top-after: ${this.marginTopAfter};
        --margin-left-after: ${this.marginLeftAfter};
        --color: ${this.markerColor};
        --line-color: ${this.lineColor};
      `;
    },
    markerMarginLeft() {
      return '0';
    },
    marginTopAfter() {
      return '4px';
    },
    marginLeftAfter() {
      return '2px';
    },
    markerHeightAfter() {
      return `${this.heightAfter}px`;
    }
  },
  methods: {
    updateLineHeight() {
      this.$nextTick(() => {
        if (this.$el.clientHeight) {
          this.heightAfter = this.calculateHeightAfter();
        }
      });
    },
    calculateHeightAfter() {
      return this.$el.clientHeight;
    }
  },
  name: 'TimelineItem'
};
</script>
<style lang="scss" scoped>
@import 'timeline-item';

.marker.circle {
  width: 8px;
  height: 8px;
  border: 1px solid var(--color);
  border-radius: 100%;
}
</style>
